import { Button, Text, VStack, Divider } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { Strata } from './Strata'

export const FinalCtaSection = () => (
  <Strata as="footer" tone="band" contentProps={{ textAlign: 'center' }}>
    <VStack spacing={6}>
      <Button as={Link} to="/sacrifices" variant="flame" size="lg" px={8}>
        View campaigns
      </Button>
      <Divider maxW="xs" mx="auto" />
      <Text fontSize="sm" color="text.muted" maxW="lg" mx="auto">
        Participating in a sacrifice campaign carries risk. Prices may change, token availability is
        not guaranteed, and campaigns may be modified or discontinued at any time. Do your own
        research before participating.
      </Text>
      <Text fontSize="xs" color="text.muted">
        altar — public sacrifice infrastructure by votum
      </Text>
    </VStack>
  </Strata>
)

export default FinalCtaSection
